module.exports = __webpack_public_path__ + "03a813fb1f68327f12332c1c6b29463b.svg";